export type IconName =
  | 'zicon-alert-diamond-filled'
  | 'zicon-alert-filled'
  | 'zicon-automation-filled'
  | 'zicon-information-filled'
  | 'zicon-sparkles-empty'
  | 'zicon-automation'
  | 'zicon-sparkles-filled'
  | 'zicon-garments'
  | 'zicon-approval'
  | 'zicon-disapproval'
  | 'zicon-smile-sad'
  | 'zicon-smile-neutral'
  | 'zicon-smile-happy'
  | 'zicon-empty-star'
  | 'zicon-tag'
  | 'zicon-question-mark'
  | 'zicon-special-handling'
  | 'zicon-non-stackable'
  | 'zicon-fire'
  | 'zicon-hq'
  | 'zicon-group'
  | 'zicon-zencargo'
  | 'zicon-alert-small'
  | 'zicon-diagonal-arrow-small'
  | 'zicon-drag-handle-small'
  | 'zicon-help-small'
  | 'zicon-information-small'
  | 'zicon-sort-ascending-small'
  | 'zicon-sort-descending-small'
  | 'zicon-updown-small'
  | 'zicon-tail-lift'
  | 'zicon-out-of-gauge'
  | 'zicon-fork-lift'
  | 'zicon-chevron-right-small'
  | 'zicon-chevron-left-small'
  | 'zicon-chevron-up-small'
  | 'zicon-chevron-down-small'
  | 'zicon-tracker'
  | 'zicon-locked'
  | 'zicon-pin-filled'
  | 'zicon-list-numbered'
  | 'zicon-port-discharge'
  | 'zicon-comment'
  | 'zicon-barcode'
  | 'zicon-csv'
  | 'zicon-caret'
  | 'zicon-forward'
  | 'zicon-unlocked'
  | 'zicon-density-dense'
  | 'zicon-publish'
  | 'zicon-link'
  | 'zicon-arrow-up-left-oval'
  | 'zicon-arrow-down-right-oval'
  | 'zicon-tick-oval'
  | 'zicon-zoom-out'
  | 'zicon-zoom-in'
  | 'zicon-menu-meatballs'
  | 'zicon-menu-meatballs-small'
  | 'zicon-demurrage'
  | 'zicon-office'
  | 'zicon-user-group'
  | 'zicon-visible'
  | 'zicon-hidden'
  | 'zicon-time'
  | 'zicon-calendar-alert'
  | 'zicon-sidebar-closed'
  | 'zicon-sidebar-open'
  | 'zicon-tasks'
  | 'zicon-workflows'
  | 'zicon-air'
  | 'zicon-road'
  | 'zicon-ship'
  | 'zicon-rail'
  | 'zicon-finance'
  | 'zicon-progress-down-oval'
  | 'zicon-arrow-diagonal-oval'
  | 'zicon-arrow-down-oval'
  | 'zicon-arrow-left-oval'
  | 'zicon-arrow-right-oval'
  | 'zicon-arrow-up-oval'
  | 'zicon-warehouse'
  | 'zicon-user'
  | 'zicon-unarchive'
  | 'zicon-trash'
  | 'zicon-text-edit'
  | 'zicon-strike-through'
  | 'zicon-profile'
  | 'zicon-un-pinner'
  | 'zicon-pinner'
  | 'zicon-pin'
  | 'zicon-phone'
  | 'zicon-orders'
  | 'zicon-mail'
  | 'zicon-mail-open'
  | 'zicon-logout'
  | 'zicon-file'
  | 'zicon-copy'
  | 'zicon-bell'
  | 'zicon-archive'
  | 'zicon-announcement'
  | 'zicon-add-user'
  | 'zicon-diagonal-arrow'
  | 'zicon-refresh'
  | 'zicon-list-lines'
  | 'zicon-sort-ascending'
  | 'zicon-sort-descending'
  | 'zicon-tick-small'
  | 'zicon-minus-small'
  | 'zicon-close-small'
  | 'zicon-add-small'
  | 'zicon-attach'
  | 'zicon-bold'
  | 'zicon-italic'
  | 'zicon-redo'
  | 'zicon-underline'
  | 'zicon-undo'
  | 'zicon-packing-list'
  | 'zicon-alert'
  | 'zicon-preview'
  | 'zicon-flag'
  | 'zicon-list'
  | 'zicon-backoffice'
  | 'zicon-upload'
  | 'zicon-send'
  | 'zicon-close'
  | 'zicon-dashboard'
  | 'zicon-labs'
  | 'zicon-intake-planning'
  | 'zicon-booking-request'
  | 'zicon-quotes'
  | 'zicon-help-centre'
  | 'zicon-network'
  | 'zicon-analytics'
  | 'zicon-guides'
  | 'zicon-adjust'
  | 'zicon-shipment'
  | 'zicon-api'
  | 'zicon-manufacturer'
  | 'zicon-reciept'
  | 'zicon-full-heart'
  | 'zicon-no-heart'
  | 'zicon-open-heart'
  | 'zicon-collapse'
  | 'zicon-tick'
  | 'zicon-warning-triangle'
  | 'zicon-tickoval'
  | 'zicon-warning-oval'
  | 'zicon-add'
  | 'zicon-arrow-down'
  | 'zicon-arrow-left'
  | 'zicon-arrow-right'
  | 'zicon-arrow-up'
  | 'zicon-box'
  | 'zicon-calendar'
  | 'zicon-chevron-down'
  | 'zicon-chevron-left'
  | 'zicon-chevron-right'
  | 'zicon-chevron-up'
  | 'zicon-cross-oval'
  | 'zicon-customs'
  | 'zicon-delay'
  | 'zicon-dots'
  | 'zicon-download'
  | 'zicon-edit'
  | 'zicon-edit-table'
  | 'zicon-filter'
  | 'zicon-frozen'
  | 'zicon-hazardous'
  | 'zicon-help'
  | 'zicon-line'
  | 'zicon-minus'
  | 'zicon-overweight'
  | 'zicon-pallet'
  | 'zicon-plane-down'
  | 'zicon-plane-up'
  | 'zicon-port-load'
  | 'zicon-refrigerated'
  | 'zicon-search'
  | 'zicon-settings'
  | 'zicon-stackable'
  | 'zicon-tower'
  | 'zicon-updown'
  | 'zicon-intake'
  | 'zicon-star'
  | 'zicon-drag-handle'
  | 'zicon-trending-down'
  | 'zicon-trending-up'
  | 'zicon-trophy'
  | 'zicon-information';

export enum Color {
  AZURE_LIGHTEST = '#f2faff',
  AZURE_LIGHTER = '#d9f0ff',
  AZURE_LIGHT = '#8cd1ff',
  AZURE_BASE = '#0d97f2',
  BRONZE = '#d98200',
  GOLD = '#d9b600',
  GREEN_LIGHT = '#daf2e7',
  GREEN_BASE = '#36b37e',
  GREEN_DARK = '#007a52',
  GREY_LIGHTEST = '#f7f7f8',
  GREY_LIGHTER = '#e6e7e9',
  GREY_LIGHT = '#b4b6bb',
  GREY_BASE = '#686b76',
  GREY_DARK = '#1d2231',
  NAVY_LIGHT = '#d9e3ff',
  NAVY_BASE = '#0e177a',
  NAVY_DARK = '#080e49',
  ORANGE_LIGHT = '#ffe8d9',
  ORANGE_BASE = '#f79a3e',
  ORANGE_DARK = '#a65517',
  PINK_BASE = '#ff7582',
  PURPLE_BASE = '#b97acd',
  RED_LIGHT = '#ffdfde',
  RED_BASE = '#f07c78',
  RED_DARK = '#b33532',
  TRANSPARENT = '#fff0',
  WHITE = '#fff',
  WHITE_10 = '#ffffff1a',
  WHITE_20 = '#fff3',
  YELLOW_BASE = '#fcc838',
  CURRENT = 'currentcolor'
}
